import React from 'react';
import {connect} from 'react-redux';
import report from '../utils/report';

function addressLines(x) {
  return (x && (x.street || x.city || x.state || x.postalCode || x.country))
    ? [x.street,
      `${x.city || ''}${(x.city && x.state) ? ', ' : ''}${x.state || ''}  ${x.postalCode || ''}`,
      x.country].filter(x => x && x.trim().length > 0)
    : ['-'];
}

function contactLines(x) {
  return x
    ? [`${x.firstName || ''}${(x.firstName && x.lastName) ? ' ' : ''}${x.lastName || ''}`,
      x.phone,
      x.email].filter(x => x && x.trim().length > 0)
    : ['-'];
}

/* eslint-disable-next-line react/prop-types */
const LinesDisplay = ({lines}) => <div>
  {lines.map((line, index) => <div key={index}>{line}</div>)}
</div>;

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    print: x => x,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    print: x => x,
  },
  {
    title: 'Address',
    dataIndex: 'address',
    render: x => <LinesDisplay lines={addressLines(x)}/>,
    print: x => addressLines(x).join('<br/>'),
  },
  {
    title: 'Contact',
    dataIndex: 'contact',
    //print: contactFormatter(true),
    render: x => <LinesDisplay lines={contactLines(x)}/>,
    print: x => contactLines(x).join('<br/>'),
  },
];

export const SuppliersReport = report("Inventory Suppliers", "suppliers", columns, 'supplierId',
  (props) => ({
    where: {
      dispensaryId: {eq: props.dispensaryId},
    },
    limit: 10000,
    order: 'name ASC',
  })
);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SuppliersReport);



// WEBPACK FOOTER //
// ./src/Supplier/SuppliersReport.js